import UploadBulkMetadataIcon from 'components/icons/upload-bulk-metadata/'
import AnimationProcessing from 'components/animations/processing'
import {mapGetters} from 'vuex'
import {UploadObject} from 'src/utils/objects/uploader'

export default {
  name: 'bulk-metadata-uploader',

  components: {
    UploadBulkMetadataIcon,
    AnimationProcessing
  },

  data () {
    return {
      uploader: UploadObject()
    }
  },

  computed: {
    ...mapGetters('bulkImport', {
      'uploading': ['uploading']
    }),
  },

  methods: {
    setUploader () {
      let $0 = this
      if (this.$el.querySelector('#qq-bulk-metadata-uploader-zone')) {
        this.uploader.create({
          context: this,
          target: '#qq-bulk-metadata-uploader-zone',
          handle: function () {
            let tabFile = $0.uploader.getSubmits()
            if (tabFile.length < 1) { return }
            $0.$store.dispatch('bulkImport/upload', {
              file: tabFile[0].file
            })
          },
          limitSingle: true
        })
      }
    }
  },

  mounted () {
    this.setUploader()
  },

  updated () {
    this.setUploader()
  }
}
